// extracted by mini-css-extract-plugin
export default {"window":"GSv3D7","close-button":"fUU_99","closeButton":"fUU_99","responsive":"QLwNmM","payment-step":"XuRusE","paymentStep":"XuRusE","content":"_XRLKN","spinner":"JDhzgX"};